export default "__VITE_ASSET__DjNhllO1__"